
import Vue from 'vue'
import isUglyYouTubeThumbnail from '@/common/utils/isUglyYouTubeThumbnail'

export default Vue.extend({
  props: ['src'],
  data(): { loaded: boolean; default_thumbnail: string } {
    return {
      default_thumbnail: require('../assets/thumbnail-default.png'),
      loaded: false,
    }
  },

  methods: {
    onLoad({ target }) {
      if (!isUglyYouTubeThumbnail(target)) {
        Vue.nextTick(() => {
          this.loaded = true
        })
      }
    },
    onError(e) {},
  },
})
